
const ProfileSection = () => {
  const credentials = [
    '岡山大学医学部 卒業',
    '岡山大学病院 整形外科 研修医',
    '岡山市内総合病院 整形外科 勤務',
    '日本整形外科学会 専門医 取得',
    'おかやま整形外科 開院',
    '日本リハビリテーション医学会 会員',
    '日本スポーツ医学会 会員',
  ];

  return (
    <section className="py-20 lg:py-32 bg-white px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Image */}
          <div className="lg:col-span-2">
            <div className="rounded-3xl overflow-hidden shadow-xl w-full h-[600px] sticky top-24">
              <img
                src="https://public.readdy.ai/ai/img_res/6daa5e4065df2535b558da7eb1fe7e38.jpg"
                alt="院長 岡山花子"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
              岡山 花子
            </h2>
            <p className="text-xl text-[#007bbb] font-medium mb-8">
              院長 / 整形外科専門医
            </p>

            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">経歴・資格</h3>
              <ul className="space-y-4">
                {credentials.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <div className="w-2 h-2 bg-[#007bbb] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                    <span className="text-gray-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                私は岡山大学医学部を卒業後、大学病院や総合病院で整形外科医としての経験を積んでまいりました。多くの患者様と向き合う中で、地域に根ざした医療の重要性を強く感じ、2000年におかやま整形外科を開院いたしました。
              </p>
              <p>
                整形外科医として最も大切にしていることは、患者様の痛みや不安に真摯に向き合い、一人ひとりに最適な治療を提供することです。症状の原因を正確に診断し、わかりやすく説明することで、患者様が安心して治療を受けられる環境づくりを心がけています。
              </p>
              <p>
                スポーツ障害から高齢者の関節痛まで、幅広い症状に対応できるよう、常に最新の医療知識と技術の習得に努めています。また、リハビリテーションにも力を入れており、患者様が一日も早く日常生活に復帰できるよう、スタッフ一同でサポートしています。
              </p>
              <p>
                地域の皆様の健康を守り、「動ける喜び」を取り戻すお手伝いができることを、私たちの誇りとしています。どんな些細なことでも、お気軽にご相談ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileSection;
